import { LOADING } from "../../app/config/constants";

export const getLoading = (state) => state.insertProcess.loading;
export const getIsExporting = (state) => state.insertProcess.exporting === LOADING.STARTED;
export const getError = (state) => state.insertProcess.error;
